import * as Newsbrief from '../'
import * as Constants from './constants'

export const addColorRow =
  (partnerCode: string) => ({type: Constants.ADD_COLOR_ROW, partnerCode, value: '', key: ''})

export const deleteColor =
  (rowId: string) => ({type: Constants.DELETE_COLOR, rowId})

export const handleValueChange =
  (update: Newsbrief.UpdateStateAction) => ({type: Constants.UPDATE_COLOR_VALUE, ...update})

export const updateColorKey =
  (update: Newsbrief.UpdateStateAction) => ({type: Constants.UPDATE_SYNTHETIC_COLOR_KEY, ...update})



// WEBPACK FOOTER //
// ./src/pages/newsbrief/color-picker/actions.ts